module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="menu-item">\n  <% if (context.id) { %>\n    <global-menu-generic-icon class="icon" data-name="<%= display.title %>" data-length="2">\n    </global-menu-generic-icon>\n  <% } %>\n  <p>\n    <%= display.title %>\n  </p>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="menu-item">\n  ');
                __stack.lineno = 2;
                if (context.id) {
                    buf.push('\n    <global-menu-generic-icon class="icon" data-name="', escape((__stack.lineno = 3, display.title)), '" data-length="2">\n    </global-menu-generic-icon>\n  ');
                    __stack.lineno = 5;
                }
                buf.push("\n  <p>\n    ", escape((__stack.lineno = 7, display.title)), "\n  </p>\n</div>\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher-menu-item.ejs
// module id = 277
// module chunks = 0 1